import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import SaudeService from '../../../../../services/saude-auth';
import Remume from './remume';


const ListarRemumes = () => {

    const [remumes, setRemumes] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [remume, setRemume] = useState("");



    async function fetchRemumes() {
        const response = await SaudeService.listarRemume();
        if (response.data.length >= 1) {
            setRemumes(response.data)
            setVazio(false)
        } else {
            setRemumes([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setRemume(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o Medicamento?')) {
            await SaudeService.deletarRemume(id)
            alert("Medicamento deletado com sucesso!")
            fetchRemumes();
        }
    }

    useEffect(() => {
        fetchRemumes();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/saude/remume/editar/${remume}`} />
        )
    } else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setRemumes={setRemumes}
                        setVazio={setVazio}
                        fetchRemumes={fetchRemumes}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={2}>
                            {remumes.map((remume, index) =>
                                <Remume
                                    fetchRemumes={fetchRemumes}
                                    remume={remume}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarRemumes;